var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userIsInvitee)?_c('div',{staticClass:"flex justify-center items-center w-full space-x-2"},[_c('AcceptBookingModal',{staticClass:"bg-indigo-gradiant w-full rounded-full text-white font-bold px-5 py-4 mr-3",on:{"reRender":_vm.reRenderComponent}}),_c('RejectBookingModal',{staticClass:"text-violet w-full"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }